// extracted by mini-css-extract-plugin
export var actionButton = "_kc-0";
export var fileInput = "_kc-2";
export var paperclip = "_kc-1";